'use client';

import React, { FC, useCallback, useState } from 'react';

import TelegramLoginButton, { TelegramUser } from 'telegram-login-button';
import { useMemberConnectTelegramMutation } from 'generated/hooks';

interface ITelegramLogin {
  botHandle?: string | null;
  onSuccess: (communitiesFound: number) => void;
}

export const TelegramLogin: FC<ITelegramLogin> = (props) => {
  const [error, setError] = useState<string>('')

  const [, telegramConnect] = useMemberConnectTelegramMutation();

  const onAuth = useCallback(async (user: TelegramUser) => {
    console.log('onAuth start');
    console.log('telegramConnect start');

    const response = await telegramConnect({
      id: `${user.id}`,
      hash: user.hash,
      authDate: `${user.auth_date}`,
      firstName: user.first_name,
      // @ts-ignore:next-line
      lastName: user?.last_name,
      username: user.username,
      photoUrl: user.photo_url
    });

    console.log('telegramConnect end');

    if (response.error) {
      console.log(response.error?.graphQLErrors[0].message ?? '', 'LLLL');
      setError(() => response.error?.graphQLErrors[0].message ?? '');
      return;
    }

    props.onSuccess(response.data?.memberConnectTelegram?.communitiesFound ?? 0);
  }, [props, telegramConnect]);

  return (
    <div className="h-[60px]">
      {!!props.botHandle && (
        <TelegramLoginButton
          botName={props.botHandle}
          dataOnauth={onAuth}
          className="w-full h-full flex justify-center"
        />
      )}
      {!!error && (
        <p className={`text-small text-error-600`}>{error}</p>
      )}
    </div>
  );
};
